// Need to use the React-specific entry point to import createApi

import { baseApi } from "./baseApi";

// using CSRF token from Redux Store

// Define a service using a base URL and expected endpoints
export const subscriptionApi = baseApi.injectEndpoints({
  reducerPath: "subscriptionApi",

  // mode: "no-cors",
  credentials: "include",
  endpoints: (builder) => ({
    getSubscriptionDetails: builder.query({
      query: () => {
        return {
          url: "get-subscriptions",
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            // authorization: `Bearer ${getToken()}`,
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSubscriptionDetailsQuery } = subscriptionApi;
